module.exports = __webpack_public_path__ + "img/normal-buy-hen.a0656b5e.png";